import React from "react";

export const Arrow = ({
  className = '',
  color = '#000000',
  width = '16px', height = '16px'
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg width={width} height={height} className={className} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill={color}>
    <path fillRule="evenodd" clipRule="evenodd" d="M9 13.887l5-5V8.18l-5-5-.707.707 4.146 4.147H2v1h10.44L8.292 13.18l.707.707z"/>
  </svg> 
);
